import { render, staticRenderFns } from "./selected-list.vue?vue&type=template&id=67dee89e&scoped=true"
import script from "./selected-list.vue?vue&type=script&lang=js"
export * from "./selected-list.vue?vue&type=script&lang=js"
import style0 from "./selected-list.vue?vue&type=style&index=0&id=67dee89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dee89e",
  null
  
)

export default component.exports